export const colorsTheme = {
  white: '#000000',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '294deg',
  'gradient-primary': '#253439',
  'gradient-secondary': '#253439',

  'primary-color': '#B19D84',
  'secondary-color': '#B19D84',
  'auxiliary-color': '#B19D84',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#B19D84',
  'secondary-button-color': '#B19D84',
  'secondary-button-color-hover': '#000',
  'secondary-button-border': '#B19D84',
  'secondary-button-border-hover': '#B19D84',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#020330',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#6366FF',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#B19D84',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#B19D84',
  'entry-message-color': '#B19D84',

  'bg-modal-color': '#FFFFFF',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#B19D84;',
  'text-gray': '#4F4F4F',

  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#B5D3FF',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#B19D84',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#B19D84',
  'echeck-bar-color2': '#B19D84',
};
